import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";

const EMPTY = { platform: "trustpilot", rating: "", count: "", url: "", as_of: "" };
const inputCls = "bg-obsidian-800 border-obsidian-600 rounded-none text-bone-100";

export default function ReviewBadgeAdmin() {
  const [form, setForm] = useState(EMPTY);
  const [live, setLive] = useState(false);

  useEffect(() => {
    api.get("/site/review-badge").then((r) => {
      if (r.data.badge) {
        setForm({ ...r.data.badge, rating: String(r.data.badge.rating), count: String(r.data.badge.count) });
        setLive(true);
      }
    });
  }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.put("/admin/review-badge", { ...form, rating: Number(form.rating), count: Number(form.count) });
      setLive(true);
      toast.success("Review badge is live on the homepage.");
    } catch (err) {
      toast.error("Check the fields — rating 1–5, https:// URL, date YYYY-MM-DD.");
    }
  };
  const clear = async () => {
    await api.delete("/admin/review-badge");
    setForm(EMPTY);
    setLive(false);
    toast.success("Badge hidden.");
  };
  const field = (k) => ({ value: form[k], onChange: (e) => setForm({ ...form, [k]: e.target.value }) });

  return (
    <section className="border border-obsidian-600 p-6" data-testid="review-badge-admin">
      <h2 className="font-serif text-2xl text-bone-100 mb-2">Review badge (homepage)</h2>
      <p className="font-sans text-sm text-bone-400 mb-5">
        Shown above the First Listeners wall once filled in. {live ? "Currently live." : "Currently hidden."}
      </p>
      <form onSubmit={save} className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <Select value={form.platform} onValueChange={(v) => setForm({ ...form, platform: v })}>
          <SelectTrigger className={inputCls} data-testid="review-badge-platform"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="trustpilot" data-testid="review-badge-platform-trustpilot">Trustpilot</SelectItem>
            <SelectItem value="g2" data-testid="review-badge-platform-g2">G2</SelectItem>
          </SelectContent>
        </Select>
        <Input type="number" step="0.1" min="1" max="5" required placeholder="Rating, e.g. 4.8" className={inputCls} data-testid="review-badge-rating-input" {...field("rating")} />
        <Input type="number" min="1" required placeholder="Number of reviews" className={inputCls} data-testid="review-badge-count-input" {...field("count")} />
        <Input type="date" required className={inputCls} data-testid="review-badge-asof-input" {...field("as_of")} />
        <Input type="url" required placeholder="https://www.trustpilot.com/review/shadowspeakjournal.com" className={`${inputCls} sm:col-span-2`} data-testid="review-badge-url-input" {...field("url")} />
        <div className="sm:col-span-2 flex gap-3">
          <Button type="submit" data-testid="review-badge-save" className="rounded-none bg-terracotta hover:bg-terracotta-deep text-obsidian-900 uppercase tracking-wider text-xs">Save & show</Button>
          {live && (
            <Button type="button" onClick={clear} data-testid="review-badge-clear" className="rounded-none bg-transparent border border-obsidian-600 text-bone-400 hover:text-terracotta hover:bg-transparent uppercase tracking-wider text-xs">Hide badge</Button>
          )}
        </div>
      </form>
    </section>
  );
}
